module.exports = __webpack_public_path__ + "static/mobilitat3-9b8607776ac16121f55a52e6312bd781.png";